export const OrgOidcUsersTestIds = {
  buttonAddOIDCUser: 'add_oidc_user_button',
  inputAddUserUsername: 'add_user_username',
  inputAddUserPassword: 'add_user_password',
  inputAddUserFirstName: 'add_user_firstname',
  inputAddUserLastName: 'add_user_lastname',
  inputAddUserEmailAddress: 'add_user_emailaddress',
  inputAddUserEmailAddressRepeat: 'add_user_emailaddress_repeat',
  buttonSubmitAddUser: 'submit_add_user',
  buttonAddUserBack: 'add_user_back',
  buttonAddUserClose: 'add_user_close',
  tableOIDCUser: 'org_oidc_user_table',
  inputAddUserPasswordRepeat: 'add_user_password_repeat',
  userTab: 'user_tab_',
  buttonAddUserContinue: 'add_user_continue',
  inputResetPassword: 'reset_password_password',
  inputResetPasswordRepeat: 'reset_password_password_repeat',
  buttonGeneratePassword: 'reset_password_generate',
  buttonResetPasswordCancel: 'reset_password_cancel',
  buttonResetPasswordSubmit: 'reset_password_submit',
  buttonResetPasswordCopy: 'reset_password_copy'
} as const;
